import { cn } from "../../lib/utils";

export const PageHeader = ({ eyebrow, title, description, actions, className }) => (
    <div data-page-header className={cn(
        "sticky top-0 z-30 bg-white/85 backdrop-blur-md border-b border-slate-200 px-6 sm:px-8 py-5",
        className
    )}>
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div className="min-w-0">
                {eyebrow && <div className="reedos-eyebrow mb-1.5">{eyebrow}</div>}
                <h1 className="font-display text-2xl sm:text-3xl tracking-tight font-bold text-slate-900 leading-tight">
                    {title}
                </h1>
                {description && (
                    // <div> (not <p>) so callers can pass complex JSX
                    // (Badges render as <div>) without triggering React's
                    // "p cannot contain div" hydration warning.
                    <div className="text-sm text-slate-500 mt-1.5 max-w-2xl">{description}</div>
                )}
            </div>
            {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
    </div>
);

export default PageHeader;
